// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__DJyrm","content":"Layout_content__yL68E","contentWithSidebar":"Layout_contentWithSidebar__qp9sL","main":"Layout_main__k7dEa"};